const MsrpProductData = class {
  constructor () {
    this.storageHandle = 'product-msrp-prices'

    try {
      const localProductData = window.sessionStorage.getItem(this.storageHandle)
      this.productData = JSON.parse(localProductData)
      if (!localProductData) { throw Error('no product price data, moving on') }
    } catch (error) {
      this.productData = {}
      console.log(error)
    }
  }

  async getMsrpProductData (handle) {
    if (this.productData[handle]) {
      return this.productData[handle]
    }

    const productJson = await this.fetchProductData(handle, 'same-origin')

    const productPriceData = {}

    if (productJson?.variants) {
      productPriceData.msrp = {
        price: productJson.compare_at_price || productJson.price,
        variants: productJson.variants.map(({ id, price, compare_at_price }) => ({
          id,
          price: compare_at_price || price
        }))
      }

      productPriceData.wholesale = {
        price: productJson.price,
        variants: productJson.variants.map(({ id, price }) => ({ id, price }))
      }
    }

    this.productData[handle] = productPriceData

    window.sessionStorage.setItem(this.storageHandle, JSON.stringify(this.productData))

    return productPriceData
  }

  async fetchProductData (handle, credentials) {
    const productJson = await fetch(`/products/${handle}.js`, {
      credentials,
      method: 'GET',
      headers: {
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(result => {
      return result.json()
    }).catch(error => {
      console.error(error)
      return false
    })

    return productJson
  }
}

window.msrpClass = new MsrpProductData()